<p-confirmdialog />
<p-toast />

<div class="container px-4 py-10">
  <block-ui>
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">
            Platform Users
          </h1>
          <p class="text-sm text-primary-500">View all of Your Platform Users</p>
        </div>
      </div>

      <!-- Tabs -->
      <p-tabMenu
        [model]="tabs"
        [activeItem]="activeTab"
        class="mt-4 border-b"></p-tabMenu>
    </div>
    <div class="w-full p-2 m-2">
      <p-table
        #dt2
        dataKey="id"
        stripedRows
        [value]="filtered_users"
        responsiveLayout="scroll"
        [paginator]="true"
        [scrollable]="true"
        [resizableColumns]="true"
        [autoLayout]="true"
        [globalFilterFields]="[
          'customer_id',
          'name',
          'is_active',
          'status',
          'next_due',
          'months_to_bill',
          'amount',
          'actual_amount',
          'asset_id.length'
        ]"
        [rows]="25"
        selectionMode="single"
        [(selection)]="selectedUser"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[25, 50, 100]">
        <ng-template #emptymessage>
          <tr>
            <td colspan="8">No platform users found.</td>
          </tr>
        </ng-template>

        <!-- Table Header -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pResizableColumn pSortableColumn="name">
              Name
              <p-sortIcon field="name" />
            </th>
            <th pResizableColumn pSortableColumn="email">
              Email
              <p-sortIcon field="email" />
            </th>
            <th>UID</th>
            <th>
            </th>
            <th></th>
          </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td>
              {{ rowData.name }}
            </td>
            <td>
              {{ rowData.email }}
            </td>
            <td>
              {{ rowData.uid }}
            </td>
            <td>
              <p-button
                (click)="menuClicked(rowData); menu.toggle($event)"
                icon="pi pi-ellipsis-v" />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-menu appendTo="body" #menu [model]="row_items" [popup]="true" />
    </div>
  </block-ui>
</div>
